import React from 'react';
import { SCard } from '../../styles/components/Card';
import { fadeInUp } from '../../variants';


type CardType = {
    name: string,
    description: string[],
    date: string | number
}

const Card = ({ description, name, date }: CardType) => {
    return (
        <SCard variants={fadeInUp}>
            <div>
                <h2>
                    {name}
                </h2>
                <div className='date'>
                    {date}
                </div>
                {description.map((text, index) => (
                    <p key={index}>
                        {text}
                    </p>
                ))}
            </div>
        </SCard>
    );
}

export default Card;